import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile, sendEmailVerification } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore"; 
import { auth, db } from '../firebase-config';
import './SignUp.css';

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Wprowadzone hasła nie pokrywają się!");
      return;
    }
    if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)) {
      alert("Hasło musi zawierać co najmniej 8 znaków, jedną wielką literę, jedną małą literę, jedną cyfrę oraz jeden znak specjalny.");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await updateProfile(user, {
        displayName: `${firstName} ${lastName}`,
      });
      await sendEmailVerification(user);
      await setDoc(doc(db, "users", user.uid), {
        firstName,
        lastName,
        email,
        phone,
      });
      alert("Konto użytkownika założone pomyślnie! Sprawdź swój e-mail, aby zweryfikować konto.");
      navigate('/');
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <form onSubmit={handleSignUp} className="signup-form">
      <div className="input-group">
        <i className="fas fa-user"></i>
        <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Imię" required />
      </div>
      <div className="input-group">
        <i className="fas fa-user"></i>
        <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Nazwisko" required />
      </div>
      <div className="input-group">
        <i className="fas fa-envelope"></i>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Adres e-mail" required />
      </div>
      <div className="input-group">
        <i className="fas fa-lock"></i>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Hasło" required />
      </div>
      <div className="input-group">
        <i className="fas fa-lock"></i>
        <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Potwierdź hasło" required />
      </div>
      <div className="input-group">
        <i className="fas fa-phone"></i>
        <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Numer telefonu" required />
      </div>
      <button type="submit">Zarejestruj się!</button>
    </form>
  );
}

export default SignUp;
